module.exports = __webpack_public_path__ + "static/media/nidalee-icon.f4f0e2ff.png";